import "./Loader.css";
import logo from "../../assets/logo/logo.png";

const Loader = () => {
  return (
    <div className="loader-container">
      <img src={logo} alt="Logo" width={80} className="logo-flyin" />
    </div>
  );
};

export default Loader;
